import React from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Label } from '@/components/ui/label'
import DebouncedInput from '../../../../debounced_input'

class EditLeadSubject extends React.Component {

  onSyllabusChange = (value) => {
    this.props.store.emit('lead:settings:subjects:update', this.props.lead.id, this.props.subject,
      {syllabus: value}
    )
  }

  onRemove = () => {
    this.props.store.emit('lead:settings:subjects:destroy', this.props.lead.id, this.props.subject.name)
  }

  render() {
    return (
      <div className="grid gap-4 bg-muted/50 px-4 py-3">
        <div className="grid gap-2">
          <Label>Subject</Label>
          <span className="text-sm">{this.props.subject.name}</span>
        </div>
        <div className="grid gap-2">
          <Label>Syllabus</Label>
          <DebouncedInput value={this.props.subject.syllabus} placeholder="Syllabus" onChange={this.onSyllabusChange}/>
        </div>
        <div className="flex justify-end gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="destructive" size="sm"><Trash2 className="size-4"/> Delete Subject</Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>Cancel</DropdownMenuItem>
              <DropdownMenuItem variant="destructive" onSelect={this.onRemove}>Delete</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button size="sm" onClick={this.props.onDone}>Done</Button>
        </div>
      </div>
    )
  }
}

export default EditLeadSubject
